"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SideBySideColumn = void 0;
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var SideBySideDivider_1 = require("./Divider/SideBySideDivider");
var classnames_1 = __importDefault(require("classnames"));
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var ImagePlaceholder_1 = require("./ImagePlaceholder");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var SideBySide_1 = require("ContentTokens/Models/SideBySide");
var Types_1 = require("@CommonFrontendBackend/ContentTokens/Types");
var DropLocationStore_1 = require("Project/Stores/DropLocationStore/DropLocationStore");
var mobx_1 = require("mobx");
var DragUtils_1 = require("Project/QwilrEditor/Behaviours/DragUtils");
var SideBySideColumn = (function (_super) {
    __extends(SideBySideColumn, _super);
    function SideBySideColumn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleDragOverColumn = function (event) {
            var _a = _this.props, dragStore = _a.dragStore, dropLocationStore = _a.dropLocationStore;
            if (!_this.renderPlaceholderForColumn) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (!_this.placeholderDropEnabled) {
                return;
            }
            if (!(0, DragUtils_1.checkIsImageDragEvent)(dragStore, event)) {
                return;
            }
            dropLocationStore.setDropLocation({
                path: _this.findImagePlaceholderInsertionPath(),
                editorId: _this.props.widgetManager.editor.uniqueId,
                type: DropLocationStore_1.DropLocationType.TwoColumnPlaceholder,
            });
        };
        _this.handleToggleOrder = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SwapOrder,
                path: _this.findSideBySidePath(),
            }));
        };
        _this.handlePickImage = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.PickImage,
                path: _this.findSideBySidePath(),
            }));
        };
        _this.handleDismissImagePlaceholder = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.DismissPlaceholder,
                path: _this.findSideBySidePath(),
            }));
        };
        _this.handleSelectImage = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_1.WidgetBlockType.SideBySide, {
                action: EditorTypes_1.SideBySideActionType.SelectSideBySide,
                path: _this.findSideBySidePath(),
            }));
        };
        _this.findSideBySidePath = function () {
            var _a = _this.props, widgetManager = _a.widgetManager, attributes = _a.attributes;
            var colPath = slate_react_1.ReactEditor.findPath(widgetManager.editor, slate_react_1.ReactEditor.toSlateNode(widgetManager.editor, attributes.ref.current));
            return colPath.slice(0, colPath.length - 1);
        };
        _this.findImagePlaceholderInsertionPath = function () {
            return _this.props.widgetManager.getPath(_this.props.element).concat([0]);
        };
        return _this;
    }
    SideBySideColumn.prototype.render = function () {
        var _this = this;
        var _a = this.props, attributes = _a.attributes, children = _a.children, columnIdx = _a.columnIdx, viewStore = _a.viewStore, sideBySideFullySelected = _a.sideBySideFullySelected, disableContentSelection = _a.disableContentSelection, propPercent = _a.percent, isHovered = _a.isHovered;
        var renderPlaceholderForColumn = this.renderPlaceholderForColumn;
        var isLeftCol = columnIdx === 1;
        var columnName = isLeftCol ? "left" : "right";
        var percent = viewStore.dragManager.isDragging ? viewStore.dragManager.drawnDragPercentage : propPercent;
        var columnPercent = isLeftCol ? percent : 100 - percent;
        var style = viewStore.dragManager.isDragging ? { width: "".concat(columnPercent, "%") } : {};
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)("side-by-side__col side-by-side__col--".concat(columnName), {
                    "side-by-side__col--one-quarter": columnPercent === SideBySide_1.SideBySideColumnSize.OneQuarter,
                    "side-by-side__col--one-half": columnPercent === SideBySide_1.SideBySideColumnSize.OneHalf,
                    "side-by-side__col--three-quarter": columnPercent === SideBySide_1.SideBySideColumnSize.ThreeQuarters,
                }), style: style, onDragOver: this.handleDragOverColumn }, attributes),
                renderPlaceholderForColumn && (react_1.default.createElement(ImagePlaceholder_1.ImagePlaceholder, { activeDropzone: this.placeholderIsActiveDropzone, dropEnabled: this.placeholderDropEnabled, onPickImage: this.handlePickImage, onDismiss: this.handleDismissImagePlaceholder })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("side-by-side__col-content", {
                        "side-by-side__col-content--hidden": renderPlaceholderForColumn,
                        "side-by-side__col-content--selection-disabled": disableContentSelection,
                    }), "data-layout-node": "true" }, children)),
            columnIdx === 1 && (react_1.default.createElement(SideBySideDivider_1.SideBySideDivider, { renderDragger: isHovered, forceShow: sideBySideFullySelected, isDragging: viewStore.dragManager.isDragging, hideDragger: !!viewStore.dragManager.snappedDragPercentage || !!viewStore.resizeManager.isResizing, renderSwapper: !viewStore.dragManager.isDragging && !viewStore.resizeManager.isResizing, onSwapperClick: this.handleToggleOrder, onDragStart: function (evt) {
                    evt.stopPropagation();
                    evt.preventDefault();
                    _this.handleSelectImage();
                    viewStore.dragManager.startDrag(evt.clientX);
                } }))));
    };
    Object.defineProperty(SideBySideColumn.prototype, "renderPlaceholderForColumn", {
        get: function () {
            var _a = this.props, columnIdx = _a.columnIdx, placeholderIndex = _a.placeholderIndex;
            return columnIdx === placeholderIndex;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideBySideColumn.prototype, "placeholderIsActiveDropzone", {
        get: function () {
            var _a = this.props, dropLocationStore = _a.dropLocationStore, widgetManager = _a.widgetManager;
            var dropLocation = this.props.dropLocationStore.dropLocation;
            if (!dropLocation) {
                return false;
            }
            if (dropLocation.type !== DropLocationStore_1.DropLocationType.TwoColumnPlaceholder) {
                return false;
            }
            return (dropLocationStore.dropLocation.editorId === widgetManager.editor.uniqueId &&
                slate_1.Path.equals(this.findImagePlaceholderInsertionPath(), dropLocation.path));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SideBySideColumn.prototype, "placeholderDropEnabled", {
        get: function () {
            return this.props.usingSidebarImages;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SideBySideColumn.prototype, "renderPlaceholderForColumn", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], SideBySideColumn.prototype, "placeholderIsActiveDropzone", null);
    SideBySideColumn = __decorate([
        mobx_react_1.observer
    ], SideBySideColumn);
    return SideBySideColumn;
}(react_1.default.Component));
exports.SideBySideColumn = SideBySideColumn;
